import type { Database } from 'sql.js';
import { queryAll } from '@core/infrastructure/driven/sqljs/sqljsSqlitePrimitives.ts';
import type { PuntoEntregaUploadedCleanupSummary } from '../../../domain/puntoEntregaModel.ts';

/** Delivery points already reported by a successful offline sync (safe to delete locally for space). */
export function listUploadedOfflinePuntosEntrega(db: Database): PuntoEntregaUploadedCleanupSummary[] {
  const sql = `
    SELECT pe.id, pe.public_id, pe.fecha_hora, e.nombre AS entrega_nombre,
           COALESCE(pec.nombre, l.nombre) AS lugar_nombre, pe.offline_uploaded_at
    FROM punto_entrega pe
    JOIN entregas e ON e.id = pe.entrega_id
    LEFT JOIN puntos_entrega_catalogo pec ON pec.id = pe.lugar_id AND pe.lugar_origen = 'catalogo'
    LEFT JOIN lugares l ON l.id = pe.lugar_id AND pe.lugar_origen = 'legacy'
    WHERE pe.offline_uploaded_at IS NOT NULL AND trim(pe.offline_uploaded_at) != ''
    ORDER BY pe.id DESC
  `;
  const rows = queryAll(db, sql, []);
  return rows.map((r) => ({
    id: Number(r.id),
    publicId: String(r.public_id ?? ''),
    fechaHora: String(r.fecha_hora ?? ''),
    entregaNombre: String(r.entrega_nombre ?? ''),
    lugarNombre: String(r.lugar_nombre ?? ''),
    offlineUploadedAt: String(r.offline_uploaded_at ?? '').trim(),
  }));
}
